module.exports = __webpack_public_path__ + "static/media/showroom.b91f35ab.svg";